import { MediaSourceVariant } from 'core/common/ui/ui-kit';
import { Policy } from 'core/flow/entities/Screens/NebGender';
import { Locales, notPaidUtmSources, paidUtmSources, Regions } from 'core/user/entities';
import { Location, LocationOption, LocationRegion, LocationRegionOption } from 'core/user/ui';
import { RenderOnlyOnClient } from '../RenderOnlyOnClient';
import { PolicyExtended } from './PolicyExtended';
import { PolicyStyled, FooterStyled } from './styled';

type LegalProps = {
  content: Policy;
  isPolicyAccepted: boolean;
  displayPolicyError: boolean;
  onPolicyClick: (accepted: boolean) => void;
};

export const Legal = ({
  content,
  isPolicyAccepted,
  displayPolicyError,
  onPolicyClick,
}: LegalProps) => {
  return (
    <RenderOnlyOnClient>
      <FooterStyled>
        <MediaSourceVariant name={paidUtmSources}>
          <LocationRegion>
            <LocationRegionOption option={Regions.CALIFORNIA}>
              <PolicyExtended
                data={content}
                onPolicyClick={onPolicyClick}
                isPolicyAccepted={isPolicyAccepted}
                withoutCheckbox
              />
            </LocationRegionOption>
            <LocationRegionOption option={Regions.OTHER}>
              <PolicyStyled content={content.basic} />
            </LocationRegionOption>
          </LocationRegion>
        </MediaSourceVariant>
        <MediaSourceVariant name={notPaidUtmSources}>
          <Location>
            <LocationOption option={Locales.US}>
              <PolicyExtended
                data={content}
                isError={displayPolicyError}
                onPolicyClick={onPolicyClick}
                isPolicyAccepted={isPolicyAccepted}
              />
            </LocationOption>
          </Location>
        </MediaSourceVariant>
      </FooterStyled>
    </RenderOnlyOnClient>
  );
};
